import { cn } from "@-/com.npmjs.cn";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@-/dev.improve.haniverse.components.ui.dropdown-menu";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { ActionMenuItem, ActionMenuProps } from "#action-menu-props";

/**
 * A menu of actions and on/off settings on Android and web, drawn by the shared JS dropdown. iOS
 * uses the system (SwiftUI) menu instead (`action-menu.ios.tsx`).
 */
export function ActionMenu({
  align,
  contentClassName,
  disabled,
  items,
  side,
  sideOffset,
  title,
  trigger,
  triggerNativeID,
}: ActionMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled} nativeID={triggerNativeID}>
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        className={contentClassName}
        side={side}
        sideOffset={sideOffset}
      >
        {title === undefined ? null : <DropdownMenuLabel>{title}</DropdownMenuLabel>}
        {items.map((item, index) =>
          item === null ? null : <ActionMenuRow item={item} key={`${index}:${item.label}`} />,
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function ActionMenuRow({ item }: { item: ActionMenuItem }) {
  if (item.kind === "checkbox") {
    return (
      <DropdownMenuCheckboxItem
        checked={item.checked}
        closeOnPress={false}
        disabled={item.disabled}
        onCheckedChange={item.onCheckedChange}
        testID={item.testID}
      >
        <Text>{item.label}</Text>
      </DropdownMenuCheckboxItem>
    );
  }
  return (
    <DropdownMenuItem
      disabled={item.disabled}
      onPress={item.onPress}
      testID={item.testID}
      variant={item.destructive === true ? "destructive" : undefined}
    >
      {item.icon === undefined ? null : (
        <Icon
          className={cn(
            "size-4",
            item.destructive === true ? "text-destructive" : "text-muted-foreground",
          )}
          name={item.icon}
        />
      )}
      <Text>{item.label}</Text>
    </DropdownMenuItem>
  );
}
